/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import AttendanceIcon from 'icons/AttendanceIcon';

const messages = defineMessages({
  title: {id: 'navigation.attendance'},
});

const AttendanceItem = () => (
  <RouteLinkItem
    iconBefore={AttendanceIcon}
    route="midas/students/attendance"
    title={messages.title}
  />
);

export default AttendanceItem;
